export default {
  TRANSMISSION: "Transmission",

  A: "Automatique",
  M: "Manuelle",
};
